import { render, staticRenderFns } from "./digit-g.vue?vue&type=template&id=00acd1da&"
import script from "./digit-g.vue?vue&type=script&lang=js&"
export * from "./digit-g.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports